import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { CreateChannelRequest, CreateChannelResponse } from '../../../type'
import { createChannel } from '../../services'

export default function useMutationCreateChannel(
	props?: UseBaseMutationOptions<CreateChannelResponse, CreateChannelRequest>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.CreateChannel],
		mutationFn: (params) => createChannel(params),
		...props,
	})
}
